// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"3508":"6381cdbf","6443":"9a885429","8139":"5249dbec"}[chunkId] + ".css";
};